import { atom } from 'recoil';

import { FilterModalTypes } from '../../components/FilterModal';

export const dividendHistoryFilterAtom = atom<FilterModalTypes.FilterAtom>({
  key: 'dividendHistoryFilterState',
  default: {
    availableFilters: [
      {
        title: 'Período',
        type: 'section',
        fieldName: 'predefinedPeriod',
        optionsColumns: 1,
        onlyOneSelection: true,
        options: [
          { label: 'Últimos 7 dias', value: '7' },
          { label: 'Últimos 15 dias', value: '15' },
          { label: 'Últimos 30 dias', value: '30' },
          { label: 'Outros', value: '-1' },
        ],
        selection: ['30'],
      },
      {
        title: 'Período desejado',
        type: 'dateRange',
        fieldName: 'dateRange',
        placeholder: 'Selecione a data inicial',
        isRequired: true,
        showOnlyIf(selectedFilters) {
          const predefinedPeriodFilter = selectedFilters.find(
            (selectedFilter) => selectedFilter.fieldName === 'predefinedPeriod'
          );

          if (predefinedPeriodFilter && predefinedPeriodFilter.filter?.[0] === '-1') {
            return true;
          }

          return false;
        },
      },
      {
        title: 'Data de aprovação',
        type: 'date',
        fieldName: 'approvalDate',
        placeholder: 'Selecione a data',
      },
      {
        title: 'Data de início',
        type: 'date',
        fieldName: 'startDate',
        placeholder: 'Selecione a data',
      },
      {
        title: 'Data de atualização',
        type: 'date',
        fieldName: 'updateDate',
        placeholder: 'Selecione a data',
      },
      {
        title: 'Prazo final',
        type: 'date',
        fieldName: 'dueDate',
        placeholder: 'Selecione a data',
      },
      {
        title: 'Valor',
        type: 'multiSlider',
        fieldName: 'assetValue',
        labelType: 'money',
        step: 100,
        min: 0,
        max: 10000000,
      },
    ],
    selectedFilters: [],
    appliedFilters: [],
  },
});
